export const environment: any = {
  production: false,
  projectUrl: 'https://demo.somosclientportal.com/',
  supabaseUrl: 'https://api.demo.somosclientportal.com/',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjogImFub24iLCJpc3MiOiAic3VwYWJhc2UiLCJpYXQiOiAxNzUwMTY1ODkzLCJleHAiOiAyMDY1Njk4NjkzfQ.WrTJ8XDLi1vbVTif8U06FZkbzzw-Idsva1KBqWg4Z1Y',
  lambdaUrl: 'https://lambda.demo.somosclientportal.com',
  // lambdaUrl: 'http://localhost:3000',
};
